/* eslint-disable no-else-return */
/* eslint-disable no-nested-ternary */
import { filter, forEach } from 'lodash';
import { sentenceCase } from 'change-case';
import React, { useRef, useState } from 'react';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Paper,
  TableHead,
  Grid,
  CardActions,
  CardContent,
  Box,
  Modal,
  TextField,
  FormControl,
  InputLabel,
  Select,
  Chip,
  OutlinedInput,
  MenuItem,
  useTheme,
  Tooltip,
  IconButton,
  Backdrop,
  CircularProgress,
  Menu,
  Link,
  FormControlLabel,
  Autocomplete,
  Divider,
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  styled,
} from '@mui/material';
// components
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, orderBy, query, setDoc, updateDoc, where } from 'firebase/firestore';
import { LoadingButton } from '@mui/lab';
import EmailEditor from 'react-email-editor';
import { httpsCallable } from 'firebase/functions';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { toPng } from 'html-to-image';
import { getDownloadURL, getStorage, ref, uploadString } from 'firebase/storage';

import Iconify from '../../../../../../components/Iconify';


import { db, functions } from '../../../../../../firebase.config';
import CheckCard from '../../../../../../components/CheckCard';
import { UserAuth } from '../../../../../../context/AuthContext';
import CustomButton from '../../../../../../components/CustomButton';
import { Variables } from '../../../../../../context/VariableContext';
import { useSnackbar } from '../../../../../../context/snackbarContext';
import FacebookPost from '../../preview/previewMobileFb';
import InstagramPost from '../../preview/previewMobileInsta';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 600,
  bgcolor: 'white',
  border: '1px solid white',
  borderRadius: '5px',
  boxShadow: 0,
  p: 3,
};

// for modal
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: (theme.vars ?? theme).palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

export default function Sum({ selectedInterst, selectedLocations, age, text, media, linkDesc, titleLink, visuelUrl, btText, visuel }) {


  const [expanded, setExpanded] = useState(false);
  const handleExpanded = (panel) => async (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const [preview, setPreview] = useState(0);
  return (

    <Box paddingBottom={10} sx={{ width: '100%' }} padding={2}>
      <Stack spacing={2} padding={2}>
        <Stack spacing={4}>
          {/** check up */}
          <Stack>
            <Stack>
              <Alert />
            </Stack>
          </Stack>
          <Grid container spacing={2} alignItems="stretch">
            <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
              
                
                  <Box sx={{ bgcolor: 'white', border: '2px solid #f2f2f2', borderRadius: '7px', padding: 2 }}>
                    <Typography variant='subtitle1'>Audience</Typography>
                    <Stack spacing={3} padding={2}>
                      <Stack spacing={1}>
                        <Typography variant='subtitle2'>Intérets</Typography>
                        <Stack paddingY={1} spacing={2} direction="row" alignItems="center">
                          {
                            selectedInterst?.map((interest, index) => (
                              <Box key={index} paddingX={1.5} paddingY={0.5} sx={{ bgcolor: '#f2f2f2', borderRadius: '50px', alignItems: 'center' }}>
                                <Typography variant='caption'>{interest?.name}</Typography>
                              </Box>
                            ))
                          }

                        </Stack>
                      </Stack>
                      <Stack spacing={1}>
                        <Typography variant='subtitle2'>Age</Typography>
                        <Stack paddingY={1} spacing={2} direction="row" alignItems="center">
                          <Stack direction={'row'} spacing={0.5} paddingX={1.5} paddingY={0.5} sx={{ bgcolor: '#f2f2f2', borderRadius: '50px', alignItems: 'center' }}>
                            <Typography variant='caption'>Min : </Typography>
                            <Typography variant='subtitle2'>{age?.min}</Typography>
                          </Stack>
                          <Stack direction={'row'} spacing={0.5} paddingX={1.5} paddingY={0.5} sx={{ bgcolor: '#f2f2f2', borderRadius: '50px', alignItems: 'center' }}>
                            <Typography variant='caption'>Max : </Typography>
                            <Typography variant='subtitle2'>{age?.max}</Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                      <Stack spacing={1}>
                        <Typography variant='subtitle2'>Localisation</Typography>
                        <Stack paddingY={1} spacing={2} direction="row" alignItems="center">
                          {
                            selectedLocations?.map((interest, index) => (
                              <Box key={index} paddingX={1.5} paddingY={0.5} sx={{ bgcolor: '#f2f2f2', borderRadius: '50px', alignItems: 'center' }}>
                                <Typography variant='caption'>{interest?.name}</Typography>
                              </Box>
                            ))
                          }
                        </Stack>
                      </Stack>
                    </Stack>
                  </Box>
                
                
                  <Box sx={{ bgcolor: 'white', height:'100%', border: '2px solid #f2f2f2', borderRadius: '7px', padding: 2 }}>
                    <Typography variant='subtitle1'>Budget & Planification</Typography>
                    <Stack spacing={3} padding={2}>

                      <Stack spacing={1}>
                        <Typography variant='subtitle2'>Budget</Typography>
                        <Stack paddingY={1} spacing={2} direction="row" alignItems="center">
                          <Stack direction={'row'} paddingX={1.5} paddingY={0.5} sx={{ bgcolor: '#f2f2f2', borderRadius: '50px', alignItems: 'center' }}>
                            <Typography variant='subtitle2'>Journalier : </Typography>
                            <Typography variant='caption'>18</Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                      <Stack direction={'row'} spacing={1}>
                        <Stack spacing={3} direction="row" alignItems="center">
                          <Stack spacing={1} sx={{ alignItems: 'start' }}>
                            <Typography variant='subtitle2'>Debut </Typography>
                            <Typography variant='caption'>18</Typography>
                          </Stack>
                          <Stack spacing={1} sx={{ alignItems: 'start' }}>
                            <Typography variant='subtitle2'>Fin</Typography>
                            <Typography variant='caption'>60</Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Box>
                
              
              </Box>
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
              <Box sx={{
                bgcolor: 'white',
                border: '2px solid #f2f2f2',
                borderRadius: '7px',
                p: 2,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                height: '100%'           // <-- clé pour matcher la hauteur de la colonne gauche
              }}>
                <Typography variant='subtitle1'>Design</Typography>
                 <Stack spacing={2} p={2} justifyContent="center" sx={{ flex: 1, minHeight: 0 }}>

                  <Stack my={2} direction='row' spacing={1} justifyContent={'center'} alignItems={'center'}>
                    <Box onClick={() => {
                      setPreview(0)
                    }} sx={preview === 0 ? { bgcolor: '#5E17EB', color: 'white', borderRadius: '30px', cursor: 'pointer' }
                      :
                      { bgcolor: '#f2f2f2', borderRadius: '30px', cursor: 'pointer' }} paddingX={1.5} paddingY={0.5} >
                      <Typography variant='caption'>Facebook</Typography>
                    </Box>
                    <Box onClick={() => {
                      setPreview(1)
                    }} sx={preview === 1 ? { bgcolor: '#5E17EB', color: 'white', borderRadius: '30px', cursor: 'pointer' }
                      :
                      { bgcolor: '#f2f2f2', borderRadius: '30px', cursor: 'pointer' }} paddingX={1.5} paddingY={0.5} >
                      <Typography variant='caption'>Instagram</Typography>
                    </Box>
                  </Stack>
                   <Stack justifyContent='center' alignItems='center' sx={{ flex: 1, minHeight: 0 }}>
                    {
                      preview === 0 ?
                        <FacebookPost text={text} media={media} linkDesc={linkDesc} linkTitle={titleLink} btText={btText} />
                        : preview === 1 ?
                          <InstagramPost text={text} media={media} visuelPreview={visuelUrl} visuel={visuel} linkDesc={linkDesc} linkTitle={titleLink} btText={btText} />
                          : null
                    }
                  </Stack>

                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Stack>
      </Stack>

    </Box>

  );
}
